import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { Testimonials, ClientLogos } from '../../components'

export const meta = {
	description: 'Learn more about our clients, services & solutions.',
	image: '/images/new/misc/blueshyft-meta.png',
	title: 'Our Clients | blueshyft',
	url: 'http://blueshyft.com.au/clients',
};

import '../../css/clients.css';
import '../../css/case-study.css';

export default class Clients extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
			<section className="case-studies">

					<h3>Featured case studies</h3>

					<p>Our effective, reliable and simple interface has attracted clients such as FedEx and GoGet, all gold standard businesses in their industries.</p>

					<p>You’re in good company, but don’t just take our word for it — check out the case studies below:</p>

					<div className="container">

							<div className="clients-tiles">

								{/* <Link to="/clients/ladbrokes" className="lb">
									<img src="/images/new/logos/case-study/lb.svg" className="tile-logo"/>
								</Link> */}

								<Link to="/clients/fedex" className="fedex-new">
									{/* <img src="/images/new/logos/case-study/news.png" className="tile-logo"/> */}
								</Link>
							
								<Link to="/clients/tnt" className="tnt">
									<img src="/images/new/logos/case-study/tnt.png" className="tile-logo"/>
								</Link>


								{/* <Link to="/clients/newscorp" className="news-new"> */}
									{/* <img src="/images/new/logos/case-study/news.svg" className="tile-logo"/> */}
								{/* </Link> */}

								<Link to="/clients/teamglobalexpress" className="tge">
									<img src="/images/new/logos/case-study/tge.svg" className="tile-logo"/>
								</Link>	

								<Link to="/clients/thelotteryoffice" className="tlo">
									<img src="/images/new/logos/case-study/tlo.svg" className="tile-logo"/>
									{/* <img src="/images/new/logos/case-study/coinjar.svg" className="tile-logo"/> */}
								</Link>

								{/* <Link to="/clients/coinjar" className="cj-new"> */}
									{/* <img src="/images/new/logos/case-study/coinjar.svg" className="tile-logo"/> */}
								{/* </Link> */}

								<Link to="/clients/goget" className="goget">
									<img src="/images/new/logos/case-study/goget.svg" className="tile-logo"/>
								</Link>

								{/* <Link to="/clients/bitcoin-australia" className="bau">
									<img src="/images/new/logos/case-study/bau.svg" className="tile-logo"/>
								</Link> */}
					
							
								{/* <Link to="/clients/newscorp" className="news">
									<img src="/images/new/logos/case-study/news.png" className="tile-logo"/>
								</Link> */}
							
								{/* <Link to="/clients/bitcoin-australia" className="bitcoin-new"> */}
									{/* <img src="/images/new/logos/case-study/bau.svg" className="tile-logo"/> */}
									{/* <img src="/images/new/logos/case-study/coinjar.svg" className="tile-logo"/> */}
								{/* </Link> */}								

							</div>
					</div>

			</section>

			<Testimonials />

			<ClientLogos noButton />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/index.js